import Instrument from "./Instrument";

export enum InstrumentCategory {
  guitars = "guitars",
  drums = "drums",
  synths = "synths",
  basses = "basses",
  perc = "percussion",
  strings = "strings",
  vox = "vox",
}

export const instrumentToCategory: {
  [instrument in Instrument]: InstrumentCategory;
} = {
  gtr_acc_fngrpck: InstrumentCategory.guitars,
  gtr_acc_strum: InstrumentCategory.guitars,
  gtr_acc_lead: InstrumentCategory.guitars,

  gtr_bass: InstrumentCategory.basses,

  drm_set: InstrumentCategory.drums,
  drm_kick: InstrumentCategory.drums,
  drm_snare: InstrumentCategory.drums,
  drm_oh: InstrumentCategory.drums,

  synth_pad: InstrumentCategory.synths,
  synth_lead: InstrumentCategory.synths,

  perc_tambo: InstrumentCategory.perc,
  perc_bongos: InstrumentCategory.perc,
  perc_shaker: InstrumentCategory.perc,

  string_ensemble: InstrumentCategory.strings,

  vox_female: InstrumentCategory.vox,
};

export const instrumentsByInstrumentCategory: {
  [category in InstrumentCategory]: Instrument[];
} = {
  [InstrumentCategory.guitars]: [
    Instrument.gtrAccFingerPicked,
    Instrument.gtrAccStrummed,
    Instrument.gtrAccLead,
  ],

  [InstrumentCategory.basses]: [Instrument.gtrBass],

  [InstrumentCategory.drums]: [
    Instrument.drmSet,
    Instrument.drmKick,
    Instrument.drmSnare,
    Instrument.drmOh,
  ],

  [InstrumentCategory.synths]: [Instrument.synthPad, Instrument.synthLead],

  [InstrumentCategory.perc]: [
    Instrument.percTambo,
    Instrument.percBongos,
    Instrument.percShaker,
  ],

  [InstrumentCategory.strings]: [Instrument.stringEnsemble],

  [InstrumentCategory.vox]: [Instrument.voxFemale],
};
